import 'slick-carousel';
import '~/js/sections/general/destinations/includes/jamaica-top-slider';
import QuickQuote from '~/js/components/global/QuickQuote';
import navigationBarHandler from '~/js/modules/destinations/navigation-bar-handler';
import animateElements from '~/js/modules/animate-elements.js';

// Navigation bar handler
const navBarWrapper = document.querySelector('.resort-nav-wrapper');

navigationBarHandler(navBarWrapper);

// Quick Quote
const datePickerElements = document.querySelector('#home-qq');

ReactDOM.render(
  <QuickQuote
    schedulerModeIndex={4}
    hasCountries={ false }
    noLabels
    defaultCountry="JM"
    quoteButtonText="Rates &amp; Availability"
    occupancyLabels={ false }
    adultsDropdownPlaceHolder="<span class='occupancy-placeholder'>Adults<span class='display-block'>(Age 16+)</span></span>"
    childrenDropdownPlaceHolder="<span class='occupancy-placeholder'>Kids<span class='display-block'>(Age 0-15)</span></span>"
  />,
  datePickerElements
);

const experienceButton = $('.js-expirience-read-more');
const experienceAdded = $('.js-expirience-added');
let isExperienceShow = false;

$('.js-island-read-more').on('click', (e) => {
  const familyDescription = $(e.currentTarget).siblings('.family-description');
  const readText = familyDescription.is(':visible') ? 'Read More' : 'Read Less';

  $(e.currentTarget).find('.family-read-more-text').text(readText);
  familyDescription.toggleClass('show');
});

const $carousel = $('#inc-carousel');
const $control = $('#inc-carousel-control');

$('.js-scroll-below').on('click', () => {
  const $main = $('html, body');
  const $heroSection = $('#hero-slider');
  const heroSectionTop = $heroSection.offset().top;
  const heroSectionHeight = $heroSection.outerHeight();
  const headerCollapsedHeight = 34;
  let stickyNavHeight = 0;

  if ($heroSection.hasClass('sticky-nav--enabled')) {
    stickyNavHeight = 80;
  }

  const scrollHere = heroSectionTop + heroSectionHeight - headerCollapsedHeight - stickyNavHeight;

  $main.animate({
    scrollTop: scrollHere
  }, 1000);
});

experienceButton.on('click', () => {
  isExperienceShow = !isExperienceShow;
  if (isExperienceShow) {
    experienceAdded.removeClass('hide');
    experienceButton.children('span').text('read less');
  } else {
    experienceAdded.addClass('hide');
    experienceButton.children('span').text('read more');
  }
});

const $inclusionSliderCounter = $('.inc-carousel .js-slick-slider-inclusions-counter');

$carousel.on('init reInit afterChange', (event, slick, currentSlide) => {
  const i = (currentSlide ? currentSlide : 0) + 1;

  $inclusionSliderCounter.text(`${i}/${slick.slideCount}`);
});

$carousel.slick({
  centerMode: true,
  cssEase: 'ease',
  fade: false,
  infinite: true,
  pauseOnFocus: true,
  pauseOnHover: false,
  speed: 500,
  variableWidth: true,
  slidesToScroll: 1,
  appendArrows: $control,
  arrows: true,
  prevArrow: '<button class="icon-button-prev arrow-prev"></button>',
  nextArrow: '<button class="icon-button-next arrow-next"></button>',
  responsive: [{
    breakpoint: 767,
    settings: {
      centerMode: false
    }
  }]
});

// Sliders
const slider = $('.js-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  prevArrow: '<span class="prev resort-slider-arrow"><i class="icon icon-button-arrow-prev"></i></span>',
  nextArrow: '<span class="next resort-slider-arrow"><i class="icon icon-button-arrow-next"></i></span>'
});

slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
  const nextImg = slick.$slides[nextSlide];
  const srcImg = nextImg.dataset.src;

  nextImg.src = srcImg;
  nextImg.addEventListener('load', () => {
    nextImg.style.opacity = 1;
  });
});

//  Tabs for Flights
class ToggleTabs {
  constructor(islands) {
    this.btnsWrap = document.querySelector('.ns-tab-btns');
    this.btns = document.querySelectorAll('.ns-tab-btn');
    this.islands = islands;
    this.activeIsland;
    this._events();
  };


  _activeTab = e => {
    const active = document.querySelectorAll(`.${this.activeIsland}`);

    for (const elem of active) {
      elem.classList.add('active');
    }
    e.target.classList.add('ns-tab-btn--active');
  };
  _removeActiveTab = () => {
    for (const island of this.islands) {
      const islandsElem = document.querySelectorAll(`.${island}`);

      for (const islandElem of islandsElem) {
        islandElem.classList.remove('active');
      }
    }
    for (const btn of this.btns) {
      btn.classList.remove('ns-tab-btn--active');
    }
  };
  _events = () => {
    this.btnsWrap.addEventListener('click', e => {
      if (e.target.classList.contains('ns-tab-btn')) {

        this.activeIsland = e.target.dataset.island;
        this._removeActiveTab();
        this._activeTab(e);
      }
    }
    );
  };
}


new ToggleTabs(['montego', 'kingston','ochorios']); // eslint-disable-line

animateElements();

const stickyNav = () => {
  const nav = document.querySelector('.resort-nav');
  const topSection = document.querySelector('#hero-slider');
  const header = document.querySelector('header');
  const topHeight = topSection.offsetTop + topSection.clientHeight - header.clientHeight;
  const headerHeight = header.clientHeight;

  if (window.pageYOffset > topHeight) {
    nav.classList.add('sticky-nav');
    document.querySelector('.resort-nav-wrapper').style.height = `${nav.clientHeight}px`;
    nav.style.top = `${headerHeight}px`;
  }
  if (window.pageYOffset < topHeight) {
    nav.classList.remove('sticky-nav');
    document.querySelector('.resort-nav-wrapper').style.height = 'auto';
  }
};

// scroll listener
window.addEventListener('scroll', () => stickyNav());
window.addEventListener('resize', () => stickyNav());

